import { createRoot } from "react-dom/client";
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ReactTagManager } from 'react-gtm-ts';

const container = document.getElementById("root");
const root = createRoot(container!);

 
ReactTagManager.init({
  code: 'GTM-59VRSCZW', // Replace with your actual GTM Container ID
  debug: false,        // Set to true to view console logs in development
  performance: false   // Set to true to defer GTM loading until user interaction
});

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
